import React, { useState } from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import { API_URL } from '../config';

function ClientIntake() {
  const [form, setForm] = useState({
    name: '', company: '', email: '', phone: '',
    address: '', city: '', state: '', zip: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const set = (field) => (e) => setForm((p) => ({ ...p, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.name.trim() || !form.phone.trim() || !form.email.trim()) {
      setError('Please fill in your name, phone, and email.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/public/client-intake`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok) {
        setDone(true);
      } else {
        setError(data.error || 'Something went wrong. Please try again.');
      }
    } catch {
      setError('Network error. Please try again.');
    }
    setSubmitting(false);
  };

  const inputStyle = {
    width: '100%', padding: '12px 14px', border: '1px solid #d1d5db',
    borderRadius: '8px', fontSize: '16px', boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '5px',
  };

  if (done) {
    return (
      <div style={{ minHeight: '100vh', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div style={{ background: 'white', borderRadius: '16px', padding: '48px 32px', textAlign: 'center', maxWidth: '420px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
          <FiCheckCircle size={56} color="#16a34a" />
          <h2 style={{ margin: '16px 0 8px', color: '#111827' }}>Thank you!</h2>
          <p style={{ color: '#6b7280', margin: 0, lineHeight: 1.5 }}>
            We've got your contact information. Someone from North Georgia Surveying will be in touch soon.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f3f4f6', padding: '24px 16px' }}>
      <div style={{ maxWidth: '520px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ background: '#1e293b', color: 'white', borderRadius: '12px 12px 0 0', padding: '24px 28px', textAlign: 'center' }}>
          <h1 style={{ margin: 0, fontSize: '22px' }}>North Georgia Surveying, Inc.</h1>
          <p style={{ margin: '6px 0 0', opacity: 0.8, fontSize: '14px' }}>New Client Information</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ background: 'white', borderRadius: '0 0 12px 12px', padding: '28px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
          <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 20px', lineHeight: 1.5 }}>
            Please fill in your contact information below and we'll add you to our system.
            Fields marked <span style={{ color: '#dc2626' }}>*</span> are required.
          </p>

          <div style={{ marginBottom: '14px' }}>
            <label style={labelStyle}>Name <span style={{ color: '#dc2626' }}>*</span></label>
            <input style={inputStyle} value={form.name} onChange={set('name')} placeholder="Full name" />
          </div>

          <div style={{ marginBottom: '14px' }}>
            <label style={labelStyle}>Company <span style={{ color: '#9ca3af', fontWeight: 400 }}>(optional)</span></label>
            <input style={inputStyle} value={form.company} onChange={set('company')} placeholder="Company name" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
            <div>
              <label style={labelStyle}>Phone <span style={{ color: '#dc2626' }}>*</span></label>
              <input style={inputStyle} type="tel" value={form.phone} onChange={set('phone')} placeholder="(706) 555-0123" />
            </div>
            <div>
              <label style={labelStyle}>Email <span style={{ color: '#dc2626' }}>*</span></label>
              <input style={inputStyle} type="email" value={form.email} onChange={set('email')} placeholder="you@example.com" />
            </div>
          </div>

          <div style={{ marginBottom: '14px' }}>
            <label style={labelStyle}>Mailing Address <span style={{ color: '#9ca3af', fontWeight: 400 }}>(optional)</span></label>
            <input style={inputStyle} value={form.address} onChange={set('address')} placeholder="Street address" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '12px', marginBottom: '20px' }}>
            <div>
              <label style={labelStyle}>City</label>
              <input style={inputStyle} value={form.city} onChange={set('city')} />
            </div>
            <div>
              <label style={labelStyle}>State</label>
              <input style={inputStyle} value={form.state} onChange={set('state')} placeholder="GA" />
            </div>
            <div>
              <label style={labelStyle}>ZIP</label>
              <input style={inputStyle} value={form.zip} onChange={set('zip')} />
            </div>
          </div>

          {error && (
            <div style={{ background: '#fee2e2', color: '#b91c1c', padding: '10px 14px', borderRadius: '8px', fontSize: '14px', marginBottom: '16px' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            style={{
              width: '100%', padding: '14px', background: submitting ? '#9ca3af' : '#16a34a',
              color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px',
              fontWeight: '600', cursor: submitting ? 'wait' : 'pointer',
            }}
          >
            {submitting ? 'Submitting...' : 'Submit My Information'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ClientIntake;
